import { TEAM_ROSTER_QUERY_KEY } from "./useInvalidateTeamQueries";

export const NURSES_QUERY_KEY_ROOT = "nurses";

/**
 * The cache entry `useRosterLookup` and HospitalDataProvider share. A standalone module so readers of the
 * cache (the error snackbar) don't import the query hooks and everything they pull in. With the schedule cache on,
 * the Team page's `/roster` entry, so the two share one request.
 */
export const departmentRosterQueryKey = (departmentId: string, isCacheEnabled: boolean): readonly unknown[] =>
	isCacheEnabled ? [...TEAM_ROSTER_QUERY_KEY, departmentId] : [NURSES_QUERY_KEY_ROOT, departmentId, undefined];
